export default __webpack_public_path__ + "i18n/translations/translation-fr.83384779.json";